/**
 * Deze klasse handelt het toevoegen of aanpassen van een group af
 *
 * @history
 * 11 augustus 2023
 * audio opname
 * 26 juli 2023
 * audio met preview na upload
 *
 * 25 juli 2023
 * audio logica
 *
 * 16 juni 2023
 * instructie kan ook een afbeelding zijn
 *
 * 14 juni 2023
 * ronde aanpassingen
 *
 * 23 november 2022
 * aangepaste database aanpak, locations
 *
 * 9 augustus 2022
 * refactor van twee componenten (add/edit) naar 1 component
 *
 * 2 augustus 2022
 * Start implementatie
 *
 */

import React from "react";
import {Popup} from "../containers/Popup";
import {FormSelect} from "../helpers/FormSelect";
import {FormPopup} from "../containers/FormPopup";

export class GroupForm extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state =
            {
                show_err: false,
                err_message: "",
                has_image: props.has_image,
                has_audio: props.has_audio,
                show_start_record: true,
                show_stop_record:false,
                audio_kind:"",
                icons: (props.icons === "" ?  [] : props.icons.split(",").map(Number))

            }

            this.icons_urls=
                [
                    "/digibord/assets/svgs/icons/Bakje_cirkel.svg",
                    "/digibord/assets/svgs/icons/Groep_cirkel.svg",
                    "/digibord/assets/svgs/icons/Lijm_cirkel.svg",
                    "/digibord/assets/svgs/icons/Lineaal_cirkel.svg",
                    "/digibord/assets/svgs/icons/Oor_cirkel.svg",
                    "/digibord/assets/svgs/icons/Papier_cirkel.svg",
                    "/digibord/assets/svgs/icons/Potlood_cirkel.svg",
                    "/digibord/assets/svgs/icons/Praten_cirkel.svg",
                    "/digibord/assets/svgs/icons/Samenwerken_cirkel.svg",
                    "/digibord/assets/svgs/icons/Schaar_cirkel.svg",
                    "/digibord/assets/svgs/icons/Uiltje_cirkel.svg",
                    "/digibord/assets/svgs/icons/Vergrootglas_cirkel.svg",
                ];



        this.iconClicked = this.iconClicked.bind(this);

        this.inputInstruction = React.createRef();
        this.inputLocation = React.createRef();

        this.storeClicked = this.storeClicked.bind(this);
        this.terugClicked = this.terugClicked.bind(this);


        // tbv afbeelding
        this.inputImageBtn = React.createRef();
        this.imagePreview = React.createRef();
        this.imageSelectClicked = this.imageSelectClicked.bind(this);
        this.imageSelected = this.imageSelected.bind(this);
        this.imageRemoveClicked = this.imageRemoveClicked.bind(this);
        this.imageRemoveBtn = React.createRef();
        this.image_data = "";
        this.remove_image = false;


        this.inputAudioBtn = React.createRef();
        this.audioPreview = React.createRef();
        this.audioSelectClicked = this.audioSelectClicked.bind(this);
        this.audioSelected = this.audioSelected.bind(this);
        this.audioRemoveClicked = this.audioRemoveClicked.bind(this);
        this.audioRemoveBtn = React.createRef();
        this.remove_audio = false;
        this.audio_data = "";

        this.audioVisualizer = React.createRef();
        this.recordStartClicked = this.recordStartClicked.bind(this);
        this.recordStopClicked = this.recordStopClicked.bind(this);
        this.mediaRecorder = null;
        this.audioCtx = false;
        this.canvasCtx = false;
        this.animationId = false;

        this.formData = new FormData();
        this.formData.append("session_id", window.app.logboek.id);
        this.formData.append("access_id1", window.app.logboek.access_id1);
        this.formData.append("access_id2", window.app.logboek.access_id2);
        if (this.props.action == "add")
        {

            this.props.instruction = "";
            this.form_url = "/add_group";
        } else
        {
            this.form_url = "/store_group";
            this.formData.append("group_id", this.props.group_id);
        }
    }


    terugClicked()
    {
        this.props.finished_callback(false, {});
    }

    imageSelectClicked()
    {
        this.inputImageBtn.current.click();
    }

    iconClicked(p_index)
    {
        console.log(p_index);

        let icons = [];
        for (let i=0; i < this.state.icons.length; i++)
        {
            icons.push(this.state.icons[i]);
        }

        if (icons.indexOf(p_index) == -1)
        {
            icons.push(p_index);
        }
        else
        {
            icons.splice(icons.indexOf(p_index), 1);

        }
        console.log(icons);
        this.setState({
            "icons": [...icons]
        })
    }

    imageSelected(event)
    {

        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj)
        {
            console.log("no file")
            return;
        }


        var reader = new FileReader();
        const _this = this;
        reader.onload = function (e)
        {
            _this.imagePreview.current.src = e.target.result;
            _this.image_data = e.target.result;
            _this.imagePreview.current.style.display = 'inline-block';
            _this.imageRemoveBtn.current.style.display = 'inline-block';
            _this.remove_image = false;
            _this.setState({"has_image": true});
        };
        reader.readAsDataURL(fileObj);
    }

    imageRemoveClicked(event)
    {
        this.remove_image = true;
        this.imagePreview.current.style.display = 'none';
        this.imageRemoveBtn.current.style.display = 'none';
        this.image_data = "";
        this.setState({"has_image": false});
    }

    audioSelectClicked()
    {
        this.inputAudioBtn.current.click();
    }

    audioSelected(event)
    {

        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj)
        {
            console.log("no file")
            return;
        }


        var reader = new FileReader();
        const _this = this;
        reader.onload = function (e)
        {
            _this.audioPreview.current.src = e.target.result;
            _this.audio_data =  e.target.result.split(',')[1];
            _this.audioPreview.current.style.display = 'inline-block';
            _this.audioRemoveBtn.current.style.display = 'inline-block';
            _this.remove_audio = false;
            _this.setState({"has_audio": true,"audio_kind":"mp3"});


        };
        reader.readAsDataURL(fileObj);
    }

    audioRemoveClicked(event)
    {
        this.remove_audio = true;
        this.audioPreview.current.style.display = 'none';
        this.audioRemoveBtn.current.style.display = 'none';
        this.audio_data = "";
        this.setState({"has_audio": false, "audio_kind":""});
    }

    visualize(stream) {
        if(!this.audioCtx) {
            this.audioCtx = new AudioContext();
        }

        const source = this.audioCtx.createMediaStreamSource(stream);

        const analyser = this.audioCtx.createAnalyser();
        analyser.fftSize = 2048;
        const bufferLength = analyser.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);

        source.connect(analyser);
        //analyser.connect(audioCtx.destination);

        const _this = this;

        draw()

        function draw() {
            const WIDTH = _this.audioVisualizer.current.width
            const HEIGHT = _this.audioVisualizer.current.height;

            _this.animationId = requestAnimationFrame(draw);

            analyser.getByteTimeDomainData(dataArray);

            _this.canvasCtx.fillStyle = 'rgb(200, 200, 200)';
            _this.canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);

            _this.canvasCtx.lineWidth = 2;
            _this.canvasCtx.strokeStyle = 'rgb(0, 0, 0)';

            _this.canvasCtx.beginPath();

            let sliceWidth = WIDTH * 1.0 / bufferLength;
            let x = 0;


            for(let i = 0; i < bufferLength; i++) {

                let v = dataArray[i] / 128.0;
                let y = v * HEIGHT/2;

                if(i === 0) {
                    _this.canvasCtx.moveTo(x, y);
                } else {
                    _this.canvasCtx.lineTo(x, y);
                }

                x += sliceWidth;
            }

            _this.canvasCtx.lineTo(_this.audioVisualizer.current.width, _this.audioVisualizer.current.height/2);
            _this.canvasCtx.stroke();

        }
    }

    recordStartClicked()
    {
        this.setState({
            show_start_record: false,
            show_stop_record:true
        });

        this.audioCtx = false;
        this.canvasCtx = this.audioVisualizer.current.getContext("2d");

        const _this = this;
        navigator.mediaDevices.getUserMedia({ audio: true }).then(function(stream)
            {
                let chunks = [];
                _this.mediaRecorder = new MediaRecorder(stream);

                _this.visualize(stream);
                _this.mediaRecorder.onstop = function(e) {
                    console.log("data available after MediaRecorder.stop() called.");

                    let audio_type = 'audio/webm;codecs=opus';
                    if (_this.mediaRecorder.mimeType != "" && _this.mediaRecorder.mimeType != audio_type)
                    {
                        audio_type = "audio/mp4";
                        _this.setState({ "has_audio": true,"audio_kind":"mp4"});
                    }
                    else
                    {
                        _this.setState({ "has_audio": true,"audio_kind":"webm"});
                    }
                    _this.remove_audio = false;

                    const blob = new Blob(chunks, { 'type' : audio_type });
                    chunks = [];
                    _this.audioPreview.current.src = window.URL.createObjectURL(blob);
                    var reader = new FileReader();

                    reader.onloadend = function ()
                    {

                        _this.audio_data = reader.result.split(',')[1];
                        _this.audioPreview.current.style.display = 'block';
                        _this.audioRemoveBtn.current.style.display = 'inline-block';
                        if (_this.animationId)
                        {
                            cancelAnimationFrame(_this.animationId);
                            _this.canvasCtx.fillStyle = 'rgb(255, 255, 255)';
                            _this.canvasCtx.fillRect(0, 0, _this.audioVisualizer.current.width, _this.audioVisualizer.current.height);
                        }
                        _this.animationId = false;
                    };
                    reader.readAsDataURL(blob);
                    console.log("recorder stopped");
                }

                _this.mediaRecorder.ondataavailable = function(e) {
                    chunks.push(e.data);
                }

                _this.mediaRecorder.start();
            },
            function(err) {
                console.log('The following error occured: ' + err);
            });
    }

    recordStopClicked()
    {
        this.mediaRecorder.stop();
        this.setState({
            show_start_record: true,
            show_stop_record:false
        })
    }

    storeClicked()
    {
        if (this.inputInstruction.current.value == "")
        {
            this.setState({"show_err": true, "err_message": "Geen instructie ingevoerd. Probeer het opnieuw"});
            return false;
        }

        this.setState({"show_err": false});
        this.formData.append("instruction", this.inputInstruction.current.value);
        this.formData.append("icons", this.state.icons.join(','));

        if (this.image_data != "")
        {
            var img = document.createElement("img");
            img.src = this.image_data;
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            // Set Width and Height

            var width = img.width;
            var height = img.height;
            if (width > height)
            {
                if (width > 500)
                {
                    height *= 500 / width;
                    width = 500;
                }
            } else
            {
                if (height > 500)
                {
                    width *= 500 / height;
                    height = 500;
                }
            }
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            this.formData.append("image", canvas.toDataURL("image/jpeg", 1)); // 100% kwaliteit
        } else
        {
            if (this.remove_image)
            {
                this.formData.append("remove_image", 'Y');
            }
        }

        if (this.audio_data != "")
        {
            this.formData.append("audio", this.audio_data);
            this.formData.append("audio_kind", this.state.audio_kind);
        } else
        {
            if (this.remove_audio)
            {
                this.formData.append("remove_audio", 'Y');
            }
        }


        const requestOptions = {
            method: 'POST',
            body: this.formData
        };

        fetch(this.form_url, requestOptions)
            .then(response => response.json())
            .then(group_json =>
            {
                if (group_json.status == "err")
                {
                    this.setState({"show_err": true, "err_message": "Opslaan niet gelukt. Probeer het opnieuw"});

                } else
                {
                    this.setState({'show_err': false});
                    this.props.finished_callback(true, group_json.data.group);
                }
            });
    }

    render()
    {


        console.log(this.state);


        return (
            <FormPopup has_close_btn={false} title={"Instructie voor " + this.props.location}>
                <div style={{"float": "left", "width": "100%"}}>
                    <h3>Tekstuele instructie</h3>
                    <textarea className={"tool__content__login__input"} name={"instruction"} style={{"width": "90%", "height": "100px"}} ref={this.inputInstruction}>{this.props.instruction}</textarea><br/>
                    <br/>
                    <h4>Ondersteunende iconen bij instructie</h4>
                    <br/>

                    {this.icons_urls.map((icon_url, icon_index) =>
                        (
                            <img src={icon_url} onClick={() => this.iconClicked(icon_index)} key={icon_index}
                                 style={(this.state.icons.indexOf(icon_index) > -1 ) ? {
                                     "border": "2px solid #75CC75",
                                     "border-radius":"50px",
                                     "width":"50px",
                                     "margin":"4px"
                                 } : {
                                     "border": "2px solid #FFF",
                                     "width":"50px",
                                     "border-radius":"50px",
                                     "margin":"4px"
                                 }}
                            />
                        )
                    )
                    }
                    <br/>
                    <br/>




                </div>
                <div style={{"float": "left", "width": "45%"}}>



                        <input type="file" accept="image/*;capture=camera" id="upload_image" name={"image"}
                               ref={this.inputImageBtn}
                               style={{"display": "none"}} onChange={this.imageSelected}
                        />


                        <img id="upload_image_preview" src={this.props.image_url}
                             style={{"max-height": "200px", "width": "auto", "margin-top": "5px", "display": (this.state.has_image) ? "inline-block" : "none", "float": "left", "margin-right": "10px"}}
                             ref={this.imagePreview}/>
                        <a href="javascript:void(0);" onClick={this.imageSelectClicked} className={"button"}
                           id="upload_image_btn">Upload afbeelding</a>
                        <a href="javascript:void(0);" onClick={this.imageRemoveClicked} className={"button"}
                           id="remove_image_btn" ref={this.imageRemoveBtn} style={{"display": (this.state.has_image) ? "inline-block" : "none"}}>Verwijder afbeelding</a>

                </div>
                <div style={{"float": "left", "width": "45%"}}>

                        <input type="file" accept="audio/mpeg;" id="upload_audio" name={"audio"}
                               ref={this.inputAudioBtn}
                               style={{"display": "none"}} onChange={this.audioSelected}
                        />


                        <audio controls style={{"display": (this.state.has_audio) ? "inline-block" : "none"}} ref={this.audioPreview} src={this.props.audio_url}>

                        </audio>
                    <canvas style={{"width":"100%","height":"60px"}} ref={this.audioVisualizer} />

                        <a href="javascript:void(0);" onClick={this.audioSelectClicked} className={"button"}
                           id="upload_audio_btn">Upload audio [mp3]</a>
                    {this.state.show_start_record && (<a href="javascript:void(0);" onClick={this.recordStartClicked} className={"button"} >Opname starten</a>)}
                    {this.state.show_stop_record && (<a href="javascript:void(0);" onClick={this.recordStopClicked} className={"button"} >Opname stoppen</a>)}
                        <br/>
                        <a href="javascript:void(0);" onClick={this.audioRemoveClicked} className={"button"}
                           id="remove_audio_btn" ref={this.audioRemoveBtn} style={{"display": (this.state.has_audio) ? "inline-block" : "none"}}>Verwijder audio</a>

                </div>
                <div style={{"width": "100%", "border-top": "1px solid #75CC75", "padding-top": "1rem","margin-top":"1rem", "float": "left"}}>
                    <a href="javascript:void(0)" className={"button"} onClick={this.terugClicked}>Terug</a>
                    <a href="javascript:void(0)" className={"button"} onClick={this.storeClicked}>Opslaan</a>

                    {this.state.show_err && (
                        <div style={{"float": "left", "width": "100%", "color": "#F00"}}>
                            <p>{this.state.err_message}</p>
                        </div>
                    )}
                </div>
            </FormPopup>

        );
    }

}
